import script from "./ModificarFormularioModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModificarFormularioModal.vue?vue&type=script&lang=ts&setup=true"

import "./ModificarFormularioModal.vue?vue&type=style&index=0&id=f74d4908&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f74d4908"]])

export default __exports__